export const tipoParcelaList = [
    {value: 1, label: 'Simples', labelDetails: 'simples'},
    {value: 2, label: 'Dupla', labelDetails: 'dupla(s)'},
    {value: 3, label: 'Tripla', labelDetails: 'tripla(s)'},
    {value: 4, label: 'Quádrupla', labelDetails: 'quádrupla(s)'},
    {value: 5, label: 'Quíntupla', labelDetails: 'quíntupla(s)'},
    {value: 6, label: 'Sêxtupla', labelDetails: 'sêxtupla(s)'},
]